import React, { FC } from 'react';
import { Text } from '../../../../../components/common';
import { Separator } from '../Separator';
import styles from './BoardInfo.scss';
import { IOuter } from './BoardInfo.types';

export const BoardInfo: FC<IOuter> = ({ name, description, isMultipleBoardsSelected }) => (
  <>
    <Text
      weight="bold"
      size={isMultipleBoardsSelected ? 'small' : 'medium'}
      title={name}
      tagName="div"
      className={styles.name}
      dataHook="board-name"
    >
      {name}
    </Text>

    <Text weight="thin" size="small" title={description} tagName="div" dataHook="board-description">
      {description}
    </Text>
    <Separator />
  </>
);
